import { put, select } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import { setToken } from './token';
import { actions as profileActions } from './profile';

const key = 'AUTH/LOGIN';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchLogin(client, store, { payload: { code: cd } }) {
  try {
    const response = yield client.post('/user/auth/login', { data: { cd } });
    yield put(actions.loadSuccess(response.result));
    yield put(setToken(response.result.session.token));
    yield put(profileActions.load());
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
